








































































import { Action, Mutation, State, Getter } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';
import {
  GET_REGISTER_FUNCTIONALITY_FORM_VISIBILITY,
  UPDATE_REGISTER_FUNCTIONALITY_FORM_VISIBILITY,
  GET_SELECTED_FUNCTIONALITY,
  UPDATE_SELECTED_FUNCTIONALITY,
  FETCH_FUNCTIONALITY_LIST,
  CREATE_FUNCTIONALITY_LIST,
  CREATE_NEW_FUNCTIONALITY,
  UPDATE_FUNCTIONALITY_LIST,
  UPDATE_FUNCTIONALITY,
  UPDATE_SYSTEM_FUNCTIONALITY,
} from '@/modules/functionality/store';
import { GET_SYSTEM_LIST } from '@/modules/system/store';
import { MessageService } from '@/services/messageService';
import { IFunctionality } from '@/modules/functionality/models';
import { ISystem } from '@/modules/system/models';

@Component({
  components: {},
})
export default class extends Vue {
  public saving: boolean = false;
  public valid: boolean = false;
  public nome: string = '';
  public state: any = {};
  public newFunctionality: IFunctionality = {
    id: 0,
    system: {
      id: 0,
      systemname: '',
      isactive: true,
    },
    idsystem: 0,
    name: '',
    description: '',
    userinterfaceid: '',
    contextdescription: '',
    isactive: true,
  };

  public nameRules: any[] = [
    (v: any) => !!v || 'Nome é obrigatório',
    (v: any) =>
      (v && v.length <= 250) || 'Nome precisa ter menos que 250 caracteres',
  ];

  @Getter(GET_SYSTEM_LIST)
  public systems: ISystem[];

  @Getter(GET_SELECTED_FUNCTIONALITY) // Recupera a funcionalidade selecionada
  public functionalitySelected: IFunctionality;

  @Getter(GET_REGISTER_FUNCTIONALITY_FORM_VISIBILITY) // Recupera flag de exibição do formulário.
  public showFunctionalityForm: boolean;

  @Action(CREATE_NEW_FUNCTIONALITY) // Cria a funcionalidade no banco.
  public createFunctionality: any;

  @Action(UPDATE_FUNCTIONALITY_LIST) // Atualiza a lista de funcionalidades.
  public updateFunctionalities: any;

  @Action(UPDATE_REGISTER_FUNCTIONALITY_FORM_VISIBILITY) // Atualiza a flag de exibição do formulário
  private setShowFunctionalityForm: any;

  @Action(UPDATE_SELECTED_FUNCTIONALITY) // Seta a funcionalidades atual selecionado.
  private setSelectedFunctionality: any;

  @Action(UPDATE_FUNCTIONALITY) // Atualiza a funcionalidade no banco.
  private updateFunctionality: any;

  @Action(FETCH_FUNCTIONALITY_LIST) // Recupera a lista de funcionalidades do banco.
  private getAllFunctionalities: any;

  @Action(CREATE_FUNCTIONALITY_LIST)
  private setAllFunctionalities: any;

  @Action(UPDATE_SYSTEM_FUNCTIONALITY) // Atualiza o sistema selecionado na listagem em tela
  private updateFunctionalitySystem: any;

  public cancelEdit() {
    this.setSelectedFunctionality(this.newFunctionality);

    this.getAllFunctionalities().then((ret: any) => {
      this.setAllFunctionalities(ret.data);
      this.setShowFunctionalityForm(!this.showFunctionalityForm);
    });
  }

  public saveFunctionality() {
    if (this.functionalitySelected.id === 0) {
      this.addFunctionality();
    } else {
      this.update();
    }
  }

  public onSystemSelect() {
    const selectedSystem: ISystem | undefined = this.systems.find(
      (c) => c.id === this.functionalitySelected.idsystem,
    );
    this.updateFunctionalitySystem(selectedSystem);
  }

  private addFunctionality() {
    this.saving = true;
    this.createFunctionality(this.functionalitySelected)
      .then((ret: any) => {
        MessageService.Success('Sucesso', 'Operação realizada com sucesso.');
        this.cancelEdit();
      })
      .finally(() => (this.saving = false));
  }

  private update() {
    this.saving = true;
    this.updateFunctionality(this.functionalitySelected)
      .then(() => {
        this.resetParameters();
      })
      .finally(() => (this.saving = false));
  }

  private resetParameters() {
    MessageService.Success('Sucesso', 'Operação realizada com sucesso.');

    this.setSelectedFunctionality(this.newFunctionality);
    this.setShowFunctionalityForm(!this.showFunctionalityForm);
  }
}
